export default __webpack_public_path__ + "static/media/l2_danek_skvrnity-min.f6a88516.jpg";